module.exports = __webpack_public_path__ + "img/wpay.a67f945c.png";